// extracted by mini-css-extract-plugin
export var footer = "index-module--footer--jqoP-";
export var graphics = "index-module--graphics--1Xeeh";
export var home = "index-module--home--bfOGH";
export var left = "index-module--left--ZlOJH";
export var logo = "index-module--logo--p0LG5";
export var right = "index-module--right--28Nbz";